import React, { useState, useEffect } from 'react';
import './App.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';




function App({message}) {
  const queryParams = new URLSearchParams(window.location.search)
  const [isLoaded, setLoaded] = useState(false)
  const [emailConfirmed, setEmailConfirm] = useState(queryParams.get("emailconfirmed"))
  const [toastMessage, setToastMessage] = useState(message)
  const notify = () => toast.success(toastMessage);

  useEffect(() => {
    if(!isLoaded && emailConfirmed !== null && toastMessage !== null) {
      notify();
    }
    setLoaded(true);
 }, [isLoaded, emailConfirmed, toastMessage]);


  return (
    <>
      <ToastContainer
        position="bottom-right"
        theme='colored'
        autoClose='10000'
        hideProgressBar={true}
        draggable={false}
      />
    </>
  );
}

export default App;
